import { getWebEnvObj } from "@/utils";
import { HomeOssUrl as CDN_URL } from "@/components/Home/utils";
// eslint-disable-next-line complexity
export const weatherImagePath = (weather: string) => {
  let imagePath = "weather1";
  switch (weather) {
    case "晴":
    case "平静":
      imagePath = "weather1";
      break;
    case "少云":
    case "晴间多云":
    case "多云":
    case "阴":
      imagePath = "weather2";
      break;
    case "有风":
    case "微风":
    case "和风":
    case "清风":
      imagePath = "weather3";
      break;

    case "强风/劲风":
    case "疾风":
    case "大风":
    case "烈风":
      imagePath = "weather4";
      break;
    case "风暴":
    case "狂爆风":
    case "飓风":
    case "热带风暴":
      imagePath = "weather5";
      break;
    case "霾":
    case "中度霾":
    case "重度霾":
    case "严重霾":
      imagePath = "weather6";
      break;
    case "阵雨":
    case "雷阵雨":
      imagePath = "weather7";
      break;
    case "雷阵雨并伴有冰雹":
      imagePath = "weather8";
      break;
    case "小雨":
    case "毛毛雨/细雨":
    case "雨":
      imagePath = "weather9";
      break;
    case "中雨":
    case "小雨-中雨":
      imagePath = "weather10";
      break;
    case "大雨":
    case "强阵雨":
    case "中雨-大雨":
      imagePath = "weather11";
      break;
    case "暴雨":
    case "大暴雨":
    case "特大暴雨":
    case "强雷阵雨":
    case "极端降雨":
    case "大雨-暴雨":
    case "暴雨-大暴雨":
    case "大暴雨-特大暴雨":
      imagePath = "weather12";
      break;
    // case '暴雨-大暴雨':
    // case '大暴雨-特大暴雨':
    //   imagePath = 'weather13';
    //   break;
    case "雨雪天气":
    case "雨夹雪":
    case "阵雨夹雪":
    case "冻雨":
      imagePath = "weather13";
      break;
    case "雪":
    case "阵雪":
    case "小雪":
      imagePath = "weather14";
      break;
    case "中雪":
    case "小雪-中雪":
      imagePath = "weather15";
      break;
    case "大雪":
    case "中雪-大雪":
      imagePath = "weather16";
      break;
    case "暴雪":
    case "大雪-暴雪":
      imagePath = "weather17";
      break;
    case "浮尘":
    case "扬沙":
      imagePath = "weather18";
      break;
    case "沙尘暴":
    case "强沙尘暴":
    case "龙卷风":
      imagePath = "weather19";
      break;
    case "雾":
    case "轻雾":
      imagePath = "weather20";
      break;
    case "浓雾":
    case "强浓雾":
    case "大雾":
    case "特强浓雾":
      imagePath = "weather21";
      break;
    case "热":
      imagePath = "weather22";
      break;
    case "冷":
      imagePath = "weather23";
      break;
    default:
      imagePath = "weather1";
      break;
  }

  return `${CDN_URL}/weather/${imagePath}.png`;
};
